import "./Skills.style.css";
import ProgressBar from "../ProgressBar/ProgressBar.component";

import { RiHtml5Fill, RiReactjsLine } from "react-icons/ri";
import {
  SiCss3,
  SiRedux,
  SiMongodb,
  SiPostman,
  SiGraphql,
  SiTypescript,
} from "react-icons/si";
import { IoLogoJavascript } from "react-icons/io";
import { AiFillGithub } from "react-icons/ai";
import { FaUbuntu, FaNodeJs } from "react-icons/fa";

const skillsData = [
  {
    text: <RiHtml5Fill />,
    progress: "95",
    bgcolor: "#149ddd",
    title: "HTML5",
  },
  {
    text: <SiCss3 />,
    progress: "90",
    bgcolor: "#149ddd",
    title: "CSS3",
  },

  {
    text: <IoLogoJavascript />,
    progress: "85",
    bgcolor: "#149ddd",
    title: "JavaScript",
  },
  {
    text: <SiTypescript />,
    progress: "85",
    bgcolor: "#149ddd",
    title: "TypeScript",
  },
  {
    text: <RiReactjsLine />,
    progress: "95",
    bgcolor: "#149ddd",
    title: "ReactJS",
  },
  {
    text: <SiRedux />,
    progress: "40",
    bgcolor: "#149ddd",
    title: "Redux",
  },
  {
    text: <FaNodeJs />,
    progress: "45",
    bgcolor: "#149ddd",
    title: "NodeJS",
  },
  {
    text: "Express.js",
    progress: "45",
    bgcolor: "#149ddd",
    fontSize: "18px",
    title: "Express.js",
  },
  {
    text: <SiGraphql />,
    progress: "40",
    bgcolor: "#149ddd",
    title: "Graphql",
  },
  {
    text: <SiMongodb />,
    progress: "95",
    bgcolor: "#149ddd",
    title: "MongoDB",
  },
  {
    text: <AiFillGithub />,
    progress: "80",
    bgcolor: "#149ddd",
    title: "GitHub",
  },
  {
    text: <SiPostman />,
    progress: "100",
    bgcolor: "#149ddd",
    title: "Postman",
  },
  // {
  //   text: <SiPowershell />,
  //   progress: "30",
  //   bgcolor: "#149ddd",
  //   title: "PowerShell",
  // },
  {
    text: <FaUbuntu />,
    progress: "50",
    bgcolor: "#149ddd",
    title: "Ubuntu",
  },
];
const Skills = () => {
  return (
    <section
      className="section-title section-container skills-container"
      id="skills"
    >
      <div className="skills-content">
        <h2>Skills</h2>
        <div className="skills">
          {skillsData.map((skill, i) => (
            <div key={i}>
              <ProgressBar
                bgcolor={skill.bgcolor}
                progress={skill.progress}
                text={skill.text}
                fontSize={skill.fontSize}
                title={skill.title ?? ""}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default Skills;
